<template>
  <div class="container">
    <div class="wrap box-con" v-for="(item,index) in orderList" :key="index">
      <div class="order-info">
        <div class=" z-flex z-flex-between">
          <div class="order-num z-flex"><i class="el-icon-document"></i>修图订单：{{item.orderNum}}</div>
          <div class="order-time"><i class="el-icon-time"></i>下单时间：{{item.orderTime}}</div>
        </div>
        <div class="title">{{item.title}}</div>
        <div class="tips">图片确认后会同步保存到您的千途图库，如需返修请先选择返修的图片，并且逐张添加返修说明</div>
      </div>
      <img class="order-sta-over" v-if="item.sta==3" src="@/assets/images/i-sta-1.png"/>
      <img class="order-sta-over" v-if="item.sta==0 || item.sta==1" src="@/assets/images/i-sta-2.png"/>
      <div class="imgs-con">
        <div class="hd z-flex z-flex-between">
          <div class="btn-group" v-if="item.sta==2">
            <el-button class="btn" icon="el-icon-refresh-left" @click="toRepair(item)">我要返修</el-button>
            <el-popconfirm
              class="btn"
              title="这笔订单是否确认验收？"
              @confirm="confirmSubmit(item)"
            >
              <el-button type="primary" slot="reference" icon="el-icon-download">确认验收</el-button>
            </el-popconfirm>
          </div>
        </div>
        <div class="bd">
          <el-row :gutter="20">
            <el-col :span="6" v-for="(subItem,subIdx) in item.imgList" :key="subIdx">
              <div class="item">
                <div class="img-wrap">
                  <el-image 
                    class="img" 
                    :src="subItem.img + `?x-oss-process=image/resize,m_lfit,w_465,h_315&x-zos-process=image/resize,m_lfit,w_465,h_315`"
                    fit="cover"
                    lazy
                    :preview-src-list="[subItem.img]"
                  >
                  </el-image>
                  <div 
                    :class="['check z-flex z-flex-center',subItem.checked?'checked':'']"
                    @click.stop="selImg(subItem)"
                    v-if="item.sta==2"
                  >
                    <i class="el-icon-check"></i>
                  </div>
                  <div class="btn-download z-flex z-flex-center" @click.stop="downloadImg(subItem)"><i class="el-icon-download"></i>下载图片</div>
                </div>
                <div class="title">{{subItem.name}}</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  data() {
    return {
      orderList:[
        {
          orderNum:'12365455666555',
          orderTime:'2022-09-15 12:00:00',
          title:'曾瑞棉修图包100张',
          sta:0,
          imgList:[
            {
              img:'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/0c7/841/0c784118e32d247d3f62a535139c2e0d.jpg',
            }
          ],
        },
        {
          orderNum:'12365455666555',
          orderTime:'2022-09-15 12:00:00',
          title:'曾瑞棉修图包100张',
          sta:1,
          imgList:[
            {
              img:'https://qsh-imgstore.oss-cn-hangzhou.aliyuncs.com/uploads/thumb/0c7/841/0c784118e32d247d3f62a535139c2e0d.jpg',
            }
          ],
        }
      ],
      selList:[],//选中图片
    };
  },
  computed: {
    
  },
  mounted() {
    this.userpsId = this.$route.query.userpsId;
    this.$axios.api.myPsCheck({userps_id: this.userpsId}, (res) => {
      if (res.code == 200) {
        if (res.data.list.length == 0) {
          this.toUrl('/ps/index');
        }
        this.orderList = res.data.list;
      }
    });
  },
  methods: {
    toUrl(url){
      this.$router.push({
        path:url,
      })
    },
    //选择图片
    selImg(item){
      let selItem = item.id;
      let selId = this.selList.indexOf(selItem);
      if(selId > -1){
        this.$set(item, 'checked', false);
        this.selList.splice(selId, 1)
      }else{
        this.$set(item, 'checked', true);
        this.selList.push(selItem);
      }
    },
    confirmSubmit(item){
      this.$axios.api.myPsConfirm({unique_no: item.orderNum}, (res) => {
        if (res.code == 200) {
          item.sta = 3;
        }
      });
    },
    toRepair(item){
      let md5s = [];
      for (let i=0; i<item.imgList.length; i++) {
        if (item.imgList[i].checked) {
          md5s.push(item.imgList[i].md5)
        }
      }
      if (md5s.length < 1) {
        return this.$message.error("请选择要返修的图片")
      }
      this.$router.push({
        path: '/my/psRepair/'+this.userpsId+'/'+item.orderNum,
        query: {
          md5: md5s.toString()
        }
      })
    },
    downloadImg(item){
      let a = document.createElement("a");
      a.style.display = 'none';
      a.href = item.img;
      a.target = "_blank";
      a.setAttribute('download', item.filename);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  },
};
</script>

<style lang="scss" scoped>
.box-con{
  padding: 30px 40px;
  margin-bottom:40px;
  border-top:2px solid $colorMain;
  position: relative;
  overflow: hidden;
}
.order-sta-over{
  width: 116px;
  height: 116px;
  position: absolute;
  right: 30px;
  top: 36px;
  opacity: .75;
}
.order-info{
  color: #999;
  font-size: 15px;
  .order-num{
    font-size: 22px;
    color: #333;
    i{
      margin-right: 6px;
      font-size: 25px;
    }
  }
  .order-time{
    color: #666;
    margin-top: -25px;
  }
  .title{
    margin-top: 15px;
  }
  .tips{
    margin-top: 20px;
  }
}

.imgs-con{
  border-top: $borderDashed;
  padding-top: 20px;
  margin-top: 20px;
  .hd{
    font-size: 14px;
    color: #999;
    .btn-group{
      .btn{
        margin-right: 10px;
      }
    }
  }
  .bd{
    .item{
      margin-top: 20px;
      .img-wrap{
        width: 100%;
        height:200px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        .img{
          width: 100%;
          height: 100%;
        }
        .check{
          position: absolute;
          right:10px;
          top:10px;
          width:26px;
          height:26px;
          background:rgba(0,0,0,.6);
          border-radius: 100%;
          cursor: pointer;
          i{
            font-size: 16px;
            color: #fff;
          }
          &.checked{
            background:$colorMain;
          }
        }
        .btn-download{
          width: 100%;
          height:36px;
          color: #fff;
          background:rgba(0,0,0,.6);
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 14px;
          cursor: pointer;
          display: none;
          i{
            margin-right: 5px;
            font-size: 18px;
          }
        }
      }
      .title{
        margin-top: 10px;
        font-size: 15px;
        @extend %textOverflow;
      }
      &:hover{
        .img-wrap{
          .btn-download{
            display: flex;
          }
        }
      }
    }
  }
}

</style>
